import React from "react";
import type { PullPlanSummary } from "../../../models";
import { formatDateMonthDay, formatRelativeTime } from "../../../utils/format";
import "./PullHistoryRow.css";

interface Props {
  pullPlan: PullPlanSummary;
  sectionLabel?: string;
  selected?: boolean;
  onClick?: () => void;
  variant?: "rail" | "tab";
}

export const STATUS_ICON: Record<PullPlanSummary["status"], string> = {
  draft: "●",
  committed: "✓",
  discarded: "✗",
};

function subtitleFor(pp: PullPlanSummary): string {
  switch (pp.status) {
    case "draft":
      return `Draft · ${formatRelativeTime(pp.updated_at)}`;
    case "committed":
      return `Committed ${formatDateMonthDay(pp.committed_at) || "—"}`;
    case "discarded":
      return `Discarded${pp.discarded_reason ? ` · "${pp.discarded_reason}"` : ""}`;
  }
}

const PullHistoryRow: React.FC<Props> = ({
  pullPlan,
  sectionLabel,
  selected = false,
  onClick,
  variant = "rail",
}) => {
  const status = pullPlan.status;
  return (
    <button
      type="button"
      className={`pull-history-row pull-history-row--${variant} pull-history-row--${status}${selected ? " is-selected" : ""}`}
      onClick={onClick}
      aria-pressed={selected}
      title={pullPlan.name}
    >
      <span className={`pull-history-row-icon pull-history-row-icon--${status}`}>
        {STATUS_ICON[status]}
      </span>
      <span className="pull-history-row-body">
        <span className="pull-history-row-name">{pullPlan.name}</span>
        {sectionLabel && variant === "tab" && (
          <span className="pull-history-row-section">{sectionLabel}</span>
        )}
        <span className="pull-history-row-subtitle">{subtitleFor(pullPlan)}</span>
      </span>
    </button>
  );
};

export default PullHistoryRow;
